import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import OurFamilyStory from "./sections/OurFamilyStory";
import OurCoreValues from "./sections/OurCoreValues";
import QuickContactSiteInfo from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <OurFamilyStory />
      <OurCoreValues />
      <QuickContactSiteInfo />
    </div>;
}